// Client-facing display helpers for deliverable titles + revisions.
//
// The backend stores the raw deliverable title (which may legacy-include a
// trailing "v1" suffix). We NEVER mutate the stored data — these helpers only
// affect what the user sees, matching backend/notifications.py so that
// emails, Daily Digest and the portal all agree on the nomenclature:
//
//     "{clean title} · Revision N"
//
// Non-trailing v-mentions ("v1 Homepage", "iPhone V handset",
// "Video Ad v2 script") are left untouched.

const TRAILING_V_RE = /\s+[vV]\s*\.?\s*\d+\s*$/;

export function displayTitle(title) {
    if (!title) return "";
    const stripped = title.replace(TRAILING_V_RE, "").replace(/\s+$/, "");
    return stripped || title;
}

export function revisionLabel(versionNumber) {
    if (versionNumber === null || versionNumber === undefined || versionNumber === "") return "";
    const n = Number(versionNumber);
    if (!Number.isFinite(n) || n <= 0 || !Number.isInteger(n)) return "";
    return `Revision ${n}`;
}
